import { type ReactNode, useContext } from "react";
import { Redirect, useLocation, useParams } from "react-router";

import { BuilderInfoContext } from "helpers/globalContext/BuilderInfoContext";
import { UserInfoContext } from "helpers/globalContext/UserInfoContext";

import { BTLoginTypes } from "types/enum";

import { routes } from "utilities/routes";

interface ISpecificationConsumerBookRedirectProps {
    /** Renders the Book View. Called only when the viewer stays on it. */
    renderBookView: () => ReactNode;
}

/**
 * The internal Book View routes. With the SpecificationGroups flag a sub or client reads specs on the List
 * route instead, so a Book link (a notification, a saved link, the conversation redirect) is sent there with
 * the same spec open and the query string kept. Builders, and everyone without the flag, stay on the Book
 * View.
 */
export function SpecificationConsumerBookRedirect({
    renderBookView,
}: Readonly<ISpecificationConsumerBookRedirectProps>) {
    const userInfo = useContext(UserInfoContext);
    const builderInfo = useContext(BuilderInfoContext);
    const { externalId } = useParams<{ externalId?: string }>();
    const { search } = useLocation();

    const isConsumer = userInfo?.loginType !== BTLoginTypes.BUILDER;
    if (isConsumer && builderInfo?.flags.specificationGroups === true) {
        return <Redirect to={routes.specification.getListLink(externalId) + search} />;
    }

    return <>{renderBookView()}</>;
}
